import { type Ref, ref } from 'vue'
import { defineStore, storeToRefs } from 'pinia'

const useSpeakToExpertModalStore = defineStore('SpeakToExpert', () => {
    const isOpen = ref(false)

    const close = () => {
        isOpen.value = false
    }
    const open = () => {
        isOpen.value = true
    }

    return {
        isOpen,
        close,
        open,
    }
})

export interface SpeakToExpertModalConfig {
    isOpen: Ref<boolean>

    close(): void

    open(): void

    runAndClose(fn: (...args: any) => any): void

    isWorkingHours: boolean
}

export function useSpeakToExpertModalConfig(): SpeakToExpertModalConfig {
    const speakToExpertStore = useSpeakToExpertModalStore()
    const { isOpen } = storeToRefs(speakToExpertStore)
    const { open, close } = speakToExpertStore

    const runAndClose = (fn: (...args: any) => any) => {
        fn()
        close()
    }

    const isWorkingHours = () => {
        const options: Intl.DateTimeFormatOptions = {
            timeZone: 'Europe/London',
            hour: 'numeric',
            hour12: false,
        }
        const formatter = new Intl.DateTimeFormat([], options)
        const hours = parseInt(formatter.format(new Date()))
        const dayOfWeek = new Date().getDay()

        // dayOfWeek 0 is Sunday
        return dayOfWeek !== 0 && hours >= 11 && hours <= 17
    }

    return {
        isOpen,
        close,
        open,
        runAndClose,
        isWorkingHours: isWorkingHours(),
    }
}
